import { render, staticRenderFns } from "./PaginaAdminBandejaCompliant.vue?vue&type=template&id=d1a4cd2e"
import script from "./PaginaAdminBandejaCompliant.vue?vue&type=script&lang=js"
export * from "./PaginaAdminBandejaCompliant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports